import { useState, type FormEvent } from "react";
import { api, errorMessage, unwrap } from "../../api/client";
import { useSession } from "../../auth/session";
import { fr } from "../../i18n/fr";
import { Dialog, Field } from "../../ui/components";

/** Password change; forced (not closable) when the password is provisional (SW-AU-07). */
export function PasswordDialog({ open, forced, onClose }: { open: boolean; forced?: boolean; onClose(): void }) {
  const s = useSession();
  const [current, setCurrent] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (pw.length < 12) { setError(fr.login.tooShort); return; }
    if (pw !== pw2) { setError(fr.login.mismatch); return; }
    setBusy(true); setError(null);
    try {
      const me = unwrap(await api.POST("/me/password", { body: { currentPassword: current, newPassword: pw } }));
      s.setMe(me);
      setCurrent(""); setPw(""); setPw2("");
      onClose();
    } catch (x) {
      setError(errorMessage(x, fr.errors));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} title={fr.login.changeTitle} onClose={() => { if (!forced) onClose(); }}>
      {forced && <p className="notice warn">{fr.login.mustChange}</p>}
      <form onSubmit={submit} className="stack">
        <Field label={fr.login.current}><input type="password" autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} required /></Field>
        <Field label={fr.login.newPassword} hint={fr.login.tooShort}><input type="password" autoComplete="new-password" value={pw} onChange={(e) => setPw(e.target.value)} required minLength={12} /></Field>
        <Field label={fr.login.confirmPassword}><input type="password" autoComplete="new-password" value={pw2} onChange={(e) => setPw2(e.target.value)} required /></Field>
        {error && <div className="error">{error}</div>}
        <div className="row end">
          {!forced && <button type="button" onClick={onClose}>{fr.common.cancel}</button>}
          <button className="primary" type="submit" disabled={busy}>{busy ? fr.common.saving : fr.common.save}</button>
        </div>
      </form>
    </Dialog>
  );
}
